<!-- @format -->

@let productDetails = orderedProductDetails();
<div
	id="drawer-content"
	class="compare-grid-drawer--content hmf-position-relative hmf-pl-0"
	(scroll)="verticalScrolling()">
	<div
		#hiddenIntersectionElement
		class="hidden-intersection-element"></div>

	<div
		class="upper-grid-sticky-container hmf-position-sticky hmf-pb-xxs"
		[class.hmf-elevated-shadow]="isSticky()">
		<plp-components-carousel-button
			class="hmf-position-absolute hmf-display-none hmf-ml-xs hmf-ml-md-s carousel-button prev"
			[class.hmf-display-block]="isScrollLeftAllowed()"
			[previous]="true"
			[ariaLabel]="'Scroll Left'"
			[showLeftArrow]="isScrollLeftAllowed()"
			(clickEvent)="scrollToSide('left')">
		</plp-components-carousel-button>

		<div
			#productCardsGridSection
			class="product-card-scrollable-area hmf-display-flex hmf-align-items-flex-start hmf-px-s hmf-px-sm-m"
			(mouseenter)="updateCurrentElement('productCardsGridSection')"
			(touchmove)="updateCurrentElement('productCardsGridSection')"
			(wheel)="updateCurrentElement('productCardsGridSection')"
			(scroll)="onHorizontalScroll($event)">
			@for (
				compareBarProduct of compareBarProducts();
				track trackByCompareBarProduct($index, compareBarProduct)
			) {
				<plp-components-compare-grid-product-card
					[isCompact]="isSticky()"
					[productDetailsData]="productDetails?.length ? productDetails[$index] : null"
					[compareBarProductData]="compareBarProduct"
					(removeButtonClick)="removeProductFromCompareGrid($event)">
				</plp-components-compare-grid-product-card>
			}
			@if (compareBarProducts().length === 1) {
				<button
					id="add-more-products-section"
					class="add-more-section hmf-pb-xxs hmf-pt-s hmf-px-xxs hmf-px-sm-xs hmf-py-sm-s"
					[class]="{ 'hmf-p-xxs': isSticky() }"
					title="Add More Products to Compare"
					(click)="addMoreProducts()">
					<div
						class="bordered-area hmf-px-m hmf-py-s hmf-display-flex hmf-flex-column align-items-center hmf-justify-content-center">
						<div
							class="add-more-icon hmf-display-flex hmf-align-items-center hmf-justify-content-center">
							<homefield-icon
								name="sign-add"
								width="16px"
								height="16px"
								aria-hidden="true"></homefield-icon>
						</div>
						<p class="hmf-body-bold-l hmf-text-align-center">
							Add more products to compare
						</p>
					</div>
				</button>
			}
		</div>

		<plp-components-carousel-button
			class="hmf-position-absolute hmf-display-none hmf-mr-xs hmf-mr-md-s carousel-button next"
			[class.hmf-display-block]="isScrollRightAllowed()"
			[previous]="false"
			[ariaLabel]="'Scroll Right'"
			[showRightArrow]="isScrollRightAllowed()"
			(clickEvent)="scrollToSide('right')">
		</plp-components-carousel-button>

		@if (isDrawerScrollable()) {
			<div class="custom-scrollbar hmf-mx-s hmf-mx-sm-m">
				<div
					class="scroll-indicator hmf-position-absolute hmf-px-sm-m"
					#scrollIndicator></div>
			</div>
		}
	</div>

	<div
		#fulfillmentGridSection
		class="fulfillment-scrollable-area grid-columns-{{
			compareBarProducts().length
		}} hmf-px-s hmf-px-sm-m"
		(mouseenter)="updateCurrentElement('fulfillmentGridSection')"
		(touchmove)="updateCurrentElement('fulfillmentGridSection')"
		(wheel)="updateCurrentElement('fulfillmentGridSection')"
		(scroll)="onHorizontalScroll($event)">
		@for (
			compareBarProduct of compareBarProducts();
			track trackByCompareBarProduct($index, compareBarProduct)
		) {
			<plp-components-fulfillment-section
				[availabilityData]="
					compareProductsAvailability().ecodeMessagingMap[compareBarProduct.ecode]
				"
				[productDetailsData]="productDetails?.length ? productDetails[$index] : null"
				[userStoreInfo]="userStoreInfo()"
				[userZipCode]="userZipCode()">
			</plp-components-fulfillment-section>
		}
	</div>
	<div
		#attributesGridSection
		class="attributes-scrollable-area grid-columns-{{
			compareBarProducts().length
		}} hmf-pb-l hmf-px-s hmf-px-sm-m"
		(mouseenter)="updateCurrentElement('attributesGridSection')"
		(touchmove)="updateCurrentElement('attributesGridSection')"
		(wheel)="updateCurrentElement('attributesGridSection')"
		(scroll)="onHorizontalScroll($event)">
		@for (
			compareBarProduct of compareBarProducts();
			track trackByCompareBarProduct($index, compareBarProduct)
		) {
			@defer (when productDetails?.length && productDetails[$index]) {
				@for (
					definingAttribute of productDetails[$index]?.style?.definingAttributes;
					track trackByCompareItemAttrribute($index, definingAttribute)
				) {
					<plp-components-attribute-section
						class="hmf-px-s hmf-display-flex hmf-align-items-flex-start hmf-align-self-stretch"
						[expanded]="
							attributeSectionExpandedList()[definingAttribute.identifier] ?? false
						"
						[name]="definingAttribute.name"
						[identifier]="definingAttribute.identifier"
						[value]="`${definingAttribute.value}`"
						(expand)="handleAttributeExpand($event)">
					</plp-components-attribute-section>
				}
			} @placeholder {
				<plp-components-skeleton-attribute-section>
				</plp-components-skeleton-attribute-section>
			}
		}
	</div>
	<h3 class="hmf-header-bold-m hmf-pt-xxs hmf-mb-s hmf-px-s hmf-px-sm-m">Specs</h3>
	<div
		#specsGridSection
		class="specs-scrollable-area grid-columns-{{
			compareBarProducts().length
		}} hmf-px-s hmf-px-sm-m"
		(mouseenter)="updateCurrentElement('specsGridSection')"
		(touchmove)="updateCurrentElement('specsGridSection')"
		(wheel)="updateCurrentElement('specsGridSection')"
		(scroll)="onHorizontalScroll($event)">
		@for (
			compareBarProduct of compareBarProducts();
			track trackByCompareBarProduct($index, compareBarProduct)
		) {
			@defer (when productDetails?.length && productDetails[$index]) {
				@for (
					descriptiveAttribute of productDetails[$index]?.style?.descriptiveAttributes;
					track trackByCompareItemAttrribute($index, descriptiveAttribute)
				) {
					<plp-components-specs-section
						class="hmf-px-s"
						[name]="descriptiveAttribute.name"
						[value]="`${descriptiveAttribute.value}`"></plp-components-specs-section>
				}
			} @placeholder {
				<plp-components-skeleton-specs-section> </plp-components-skeleton-specs-section>
			}
		}
	</div>
</div>
